import { PublicNav, PublicFooter } from "@/components/app/PublicNav";
import { Building2, GraduationCap, Mail, MapPin } from "lucide-react";

export default function Contact() {
  return (
    <div className="min-h-screen bg-slate-50">
      <PublicNav />
      <section className="max-w-3xl mx-auto px-6 py-16">
        <span className="gc-label">Kontak</span>
        <h1 className="gc-h1 mt-3">Hubungi Tim Pengembang GREENCON HPP.</h1>
        <p className="mt-4 text-slate-600">Untuk demo, pelatihan, kerja sama diseminasi, atau kolaborasi penelitian, silakan hubungi tim pengembang di <strong>Politeknik Negeri Manado</strong> melalui kanal resmi institusi.</p>
        <div className="mt-8 grid md:grid-cols-3 gap-4">
          <div className="gc-card">
            <GraduationCap className="text-emerald-600 w-6 h-6" />
            <div className="mt-3 font-cabinet font-bold">Pengembang Sistem</div>
            <p className="text-sm text-slate-600 mt-1">Politeknik Negeri Manado — Tim Peneliti & Pengabdian Masyarakat</p>
          </div>
          <div className="gc-card">
            <MapPin className="text-emerald-600 w-6 h-6" />
            <div className="mt-3 font-cabinet font-bold">Lokasi</div>
            <p className="text-sm text-slate-600 mt-1">Manado, Sulawesi Utara — Indonesia</p>
          </div>
          <div className="gc-card">
            <Mail className="text-emerald-600 w-6 h-6" />
            <div className="mt-3 font-cabinet font-bold">Kanal Resmi</div>
            <p className="text-sm text-slate-600 mt-1">Kontak email dan telepon tersedia melalui website resmi Politeknik Negeri Manado.</p>
          </div>
        </div>
        <p className="mt-8 text-xs text-slate-500 border-t pt-4 border-slate-200">Untuk melindungi data pribadi, nomor telepon dan NIP tim peneliti tidak ditampilkan pada halaman publik.</p>
      </section>
      <PublicFooter />
    </div>
  );
}
